import React, {
    useState
} from "react";

import LeftMenu
from "../../../components/LeftMenu";

import CmsEntryCard
from "./CmsEntryCard";

import "./CmsEntry.css";


import CmsSiteEditor from "./CmsSiteEditor";


//============================================================
//
// Eva CMS Entry
//
//============================================================

export default function CmsEntry()
{

    //--------------------------------------------------------
    // Dummy sites
    //--------------------------------------------------------

	const [sites, setSites] =
	    useState([
	        {
	            id: 1,
	            siteKey: "eva",
	            siteType: "EVA",
	            title: "Eva",
	            description:
	                "AI knowledge, training, guided walkthroughs, questionnaires and briefings.",
	            image: "/eva/images/eva_square.png"
	        },
	        {
	            id: 2,
	            siteKey: "building-portal",
	            siteType: "WEBSITE",
	            title: "Building Portal",
	            description:
	                "Building information, facilities, documents and occupant services.",
	            image: "/eva/images/square_website1.png"
	        },
	        {
	            id: 3,
	            siteKey: "visitor-website",
	            siteType: "WEBSITE",
	            title: "Visitor Website",
	            description:
	                "Visitor information, directions, facilities and useful guidance.",
	            image: "/eva/images/square_website2.png"
	        }
	    ]);


    const [selectedSite, setSelectedSite] =
        useState(null);


    //--------------------------------------------------------
    // Open site
    //--------------------------------------------------------

    const handleOpenSite =
        function(site)
        {

            setSelectedSite(
                site
            );

        };


    //--------------------------------------------------------
    // Add site (temporary dummy behaviour)
    //--------------------------------------------------------

    const handleAddSite =
        function()
        {

            const nextNumber =
                sites.length + 1;

            const newSite =
            {
                id: Date.now(),
                siteKey: "new-site-" + nextNumber,
                siteType: "WEBSITE",
                title: "New Website " + nextNumber,
                description:
                    "A new client website ready for configuration.",
                image: null
            };

            setSites(
                function(current)
                {
                    return [
                        ...current,
                        newSite
                    ];
                }
            );

            setSelectedSite(
                newSite
            );

        };


		if (selectedSite)
		{
		    return (
		        <CmsSiteEditor
		            site={selectedSite}
		            onBack={() => setSelectedSite(null)}
		        />
		    );
		}	
		
    //========================================================
    // Render
    //========================================================

    return (

        <div className="cms-entry">

            <div className="cms-entry-background" />

            <main className="cms-entry-content">

                <div className="cms-entry-heading">

                    <div>

                        <div className="cms-entry-eyebrow">
                            OMNISCAN
                        </div>

                        <h1>
                            Content Management
                        </h1>

                        <p>
                            Manage Eva, client websites and
                            digital experiences.
                        </p>

                    </div>

                    <div className="cms-entry-count">
                        {sites.length} EXPERIENCES
                    </div>

                </div>


                <div className="cms-entry-grid">

                    {
                        sites.map(
                            function(site)
                            {

                                return (

                                    <CmsEntryCard
                                        key={site.id}
                                        title={site.title}
                                        description={site.description}
                                        image={site.image}
                                        siteType={site.siteType}
                                        selected={
                                            selectedSite
                                            &&
                                            selectedSite.id === site.id
                                        }
                                        onClick={
                                            function()
                                            {
                                                handleOpenSite(site);
                                            }
                                        }
                                    />

                                );

                            }
                        )
                    }


                    <CmsEntryCard
                        isAddNew={true}
                        title="Add New"
                        description="Create a new website or portal."
                        onClick={handleAddSite}
                    />

                </div>

            </main>

            <LeftMenu />

        </div>

    );

}